var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portfolio-filter-link',{attrs:{"filterLayout":_vm.filterLayout}}),(true)?_c('portfolio-list-link',{attrs:{"listLayout":_vm.listLayout}}):_c('portfolio-empty-link',{attrs:{"emptyLayout":_vm.emptyLayout}}),_c('pagination-link',{attrs:{"paginationLayout":_vm.paginationLayout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }